import { CmsReferralAction } from 'types/cms/collection-types'
import { BlocksContent } from '@strapi/blocks-react-renderer'

/**
 * Replace the variable {{ name }} in the active action's title and description
 * @param {CmsReferralAction} currentlyActiveAction
 * @param {string} replaceNameBy
 */
export const replaceActiveActionName = (currentlyActiveAction: CmsReferralAction, replaceNameBy: string) => {
  if (currentlyActiveAction?.websiteHeroReceiver) {
    currentlyActiveAction.websiteHeroReceiver.title = currentlyActiveAction.websiteHeroReceiver.title?.replace('{{ name }}', replaceNameBy)

    currentlyActiveAction.websiteHeroReceiver.description = currentlyActiveAction?.websiteHeroReceiver?.description?.map((node) => ({
      ...node,
      children: node.children.map((item) => {
        if ('text' in item) {
          return {
            ...item,
            text: (item.text as string).replace('{{ name }}', replaceNameBy)
          }
        }
        return item
      })
    })) as BlocksContent
  }

  if (currentlyActiveAction?.shareLinkSeo?.metaDescription) {
    currentlyActiveAction.shareLinkSeo.metaDescription = currentlyActiveAction.shareLinkSeo.metaDescription.replace(
      '{{ name }}',
      replaceNameBy
    )
  }
}
